import { render, staticRenderFns } from "./IbNavigationButtonNext.vue?vue&type=template&id=7aba9a85&scoped=true"
import script from "./IbNavigationButtonNext.vue?vue&type=script&lang=js"
export * from "./IbNavigationButtonNext.vue?vue&type=script&lang=js"
import style0 from "./IbNavigationButtonNext.vue?vue&type=style&index=0&id=7aba9a85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aba9a85",
  null
  
)

export default component.exports